import { normalize } from 'normalizr';
import { list } from '@/dex-shared/helpers/normalizr_schema';
import { query, mutation } from '@/dex-shared/helpers/graphql';
import AdminListItemModel from '@/models/AdminListItemModel';

export default {
  async CREATE_LIST({ commit, rootState }: any) {
    const userId = rootState.auth.user.id;
    const response = await mutation(
      `mutation CreateList($userId: Int!) {
        createList(input: {
          list: {
            userId: $userId
            draft: true
          }
        }) {
          list {
            id
          }
        }
      }`,
      {
        userId,
      },
    );
    commit('UPDATE_ENTITY', {
      entity: 'lists',
      data: response.data.createList.list,
    });
    return response.data.createList.list.id;
  },
  async DELETE_LIST({ commit, getters, dispatch }: any, listId: number) {
    const response = await mutation(
      `mutation DeleteList($listId: Int!) {
        deleteListById(input: {
          id: $listId
        }) {
          list {
            id
          }
        }
      }`,
      {
        listId,
      },
    );
  },
  async PUSH_LIST_BY_ID({ getters, dispatch, commit }: any, listId: number) {
    const list = getters.listById(listId);
    list.publishDate = list.publishDate || new Date();
    list
      .listItems()
      .forEach((listItem: AdminListItemModel, position: number) => {
        commit('UPDATE_ENTITY_PROP', {
          id: listItem.id,
          entity: 'list_items',
          propToUpdate: 'position',
          value: position,
        });
      });
    dispatch('UPDATE_LIST_POSITIONS', list.listItems());
    await mutation(
      `mutation PushList(
          $id: Int!,
          $name: String!,
          $description: String,
          $type: String,
          $author: String,
          $publishDate: Datetime
        ) {
        updateListById(input: {
          id: $id
          listPatch: {
            draft: false
            name: $name
            description: $description
            type: $type
            author: $author
            publishDate: $publishDate
          }
        }) {
          list {
            id
          }
        }
      }`,
      list.raw(),
    );
  },
  async PULL_LIST_BY_ID({ commit }: any, listId: number) {
    const response = await query(
      `query PullList($listId: Int!) {
        listById(id: $listId) {
          id
          name
          type
          author
          publishDate
          description
          listItemsByListId {
            nodes {
              id
              position
              listId
              questionByQuestionId {
                id
                title
                contentsByQuestionId {
                  nodes {
                    id
                    position
                    questionId
                    textByTextId {
                      id
                      body
                      alignment
                      source
                    }
                    imageByImageId {
                      id
                      url
                      source
                      resizeFactor
                      description
                    }
                    videoByVideoId {
                      id
                      providerId
                      providerType
                    }
                  }
                }
              }
              videoByVideoId {
                id
                providerId
                providerType
                description
                name
                duration
              }
              articleByArticleId {
                id
                title
                contentsByArticleId {
                  nodes {
                    id
                    position
                    articleId
                    textByTextId {
                      id
                      body
                      alignment
                      source
                    }
                    imageByImageId {
                      id
                      url
                      source
                      resizeFactor
                      description
                    }
                    videoByVideoId {
                      id
                      providerId
                      providerType
                    }
                  }
                }
              }
            }
          }
        }
      }`,
      {
        listId,
      },
    );
    if (response.data.listById) {
      const normalizedResponse = normalize(response.data.listById, list);
      commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
    } else {
      return 404;
    }
  },
};
